import { render, staticRenderFns } from "./TresIndicadoresPreNatal.vue?vue&type=template&id=3fa3121c"
import script from "./TresIndicadoresPreNatal.vue?vue&type=script&lang=js"
export * from "./TresIndicadoresPreNatal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports